const duplicateTranslationKey = (key: string): string => key;

export const translationsDashboard_da_part1 = {
  loadingConversations: "Loader Samtaler...",
  sidebarTitle: "Samtaler",
  goToLivechat: "Gå til livechat",
  livechatAvailable: "Denne samtale er tilgængelig i livechat tilstand...",
  showFilters: "Vis filtre",
  hideFilters: "Skjul filtre",
  clearFilters: "Fjern filtre",
  remove: "Fjern",
  refresh: "Opdater",
  filtersPanelTitle: "Filtre",
  filtersPanelHint: "Afgræns listen og søgningen",
  quickFilters: "Hurtige filtre",
  noToken: "Token ikke fundet",
  bugStatus: "Fejlstatus",
  customerRating: "Kunde vurdering",
  Tags: "Underemner",
  Topic: "Emne",
  topicArchivedLabel: "arkiveret",
  topicOtherOption: "Andet",
  conversationSyncDelayed: "Opdateringer forsinket. Genopretter forbindelsen…",
  uncategorized: "Ikke kategoriseret samtale",
  noConvoSelected: "Vælg en samtale for at se detaljerne.",
  reported: "rapporteret",
  report: "Rapportér",
  internal: "intern",
  resolved: "løst",
  suggestion: "idé",
  test_feedback: "test-feedback",
  ai_report: "AI-rapport",
  noStatus: "ingen",
  markResolved: "Markér som løst",
  removeStatus: "Fjern fejlstatus",
  reportBug: "Rapportér fejl",
  reportInternalBug: "Rapportér intern fejl",
  reportSuggestion: "Rapportér idé",
  reportCriticalBug: "Rapportér kritisk fejl",
  reportAdminBug: "Rapportér admin fejl",
  reportAiReport: "AI-rapport",
  reportBugTooltip:
    "Brug ved almindelige fejl eller uventet adfærd i samtalen eller chatbotten, der skal dokumenteres.",
  reportInternalBugTooltip:
    "Brug ved fejl, der primært angår jeres organisation internt, og som typisk ikke blokerer slutbrugeren.",
  reportCriticalBugTooltip:
    "Brug ved alvorlige fejl, der blokerer brugere eller kræver hurtig handling.",
  reportAdminBugTooltip:
    "Brug ved fejl i dashboard eller admin-funktioner (kun synligt som admin-rapport).",
  reportAiReportTooltip:
    "Brug til rapporter indsendt af AI-agenter (kun synlige for administratorer).",
  reportSuggestionTooltip:
    "Brug til forbedringsforslag eller idéer - ikke til egentlige fejl eller nedbrud.",
  critical_bug: "kritisk fejl",
  admin_bug: "admin fejl",
  userRating: "Bruger vurdering",
  ratingFeedback: "Feedback",
  purchaseYes: "Denne bruger foretog et køb.",
  purchaseNo: "Denne bruger har ikke foretaget et køb.",
  all: "Alle",
  date: "Dato",
  conversationID: "Samtale ID",
  showBugReport: "Vis fejlrapport",
  hideBugReport: "Skjul fejlrapport",
  reportTypeOptions: "Vælg rapporttype eller tilføj kommentar",
  addCommentOrViewComments: "Tilføj kommentar / Se kommentarer",
  translateButton: "Oversæt",
  translatingButton: "Oversætter...",
  selectLanguageOption: "Vælg sprog",
  thumbsUp: "Tommel op",
  thumbsDown: "Tommel ned",
  unviewed: "Uvist",
  markAsUnread: "Markér som ulæst",
  delete: "Slet",
  conversationActions: "Samtalehandlinger",
  view: "Visning",
  dashboardView: "Dashboard-visning",
  chatbotView: "Chatbot-visning",
  chatbotViewLoading: "Indlæser chatbot-visning",
  chatbotViewLoadError: "Kunne ikke indlæse chatbot-visningen.",
  chatbotViewRetry: "Prøv igen",
  typeYourAnswer: "Skriv dit svar her...",
  agentName: "Agentnavn",
  saveAgentName: "Gem Agentnavn",
  previous: "Forrige",
  next: "Næste",
  agentNameLabel: "Dit agentnavn",
  agentNamePlaceholder: "Indtast dit agentnavn",
  agentNameSaved: "Agentnavn gemt!",
  searchConversationsPlaceholder: "Søg efter samtaler, ID'er eller bruger-ID'er...",
  noConversationsMatchFilters: "Ingen samtaler matcher dine filtre.",
  noConversationsMatchFiltersHint:
    "Prøv at fjerne filtre eller søg efter et samtale-ID eller bruger-ID.",
  conversationsLoadFailed: "Samtalerne kunne ikke indlæses.",
  conversationsLoadFailedHint:
    "Prøv igen. Hvis det bliver ved med at fejle, så søg i færre chatbots eller en kortere periode.",
  noMessages: "Ingen beskeder endnu",
  endOfList: "Slut på listen",
  loadingMoreConversations: "Indlæser flere samtaler",
  pageLabel: "Side",
  userIDLabel: "Bruger ID",
  ligegyldigLabel: "Ligegyldig",
  ligegyldigYes: "Ja",
  ligegyldigNo: "Nej",
  freshdeskFormVisualOnly: "Dette er kun en visuel fremvisning af kontaktformularen",
  freshdeskContactSupport: "Kontakt kundeservice",
  freshdeskYourEmail: "Din email:",
  freshdeskEmailPlaceholder: "eksempel@mail.com",
  freshdeskSupportMessage: "Besked til kundeservice:",
  freshdeskMessagePlaceholder: "Skriv din besked her...",
  freshdeskUploadImageOptional: "Upload billede (valgfrit):",
  freshdeskChooseFile: "Vælg fil",
  freshdeskNoFileChosen: "Ingen fil valgt",
  freshdeskSendInquiry: "Send henvendelse",
  leadgenContactForm: "Kontaktformular",
  contactFormSubmitted: "Kontaktformular indsendt",
  originalFormDisplayUnavailable:
    "Formularens oprindelige visning blev ikke gemt for denne besked.",
  contactFormSubmittedDescription: "Kunden har udfyldt kontaktformularen nedenfor.",
  livechatHandoverSent: "Sendt til livechat",
  livechatHandoverSentDescription:
    "Kunden har accepteret at blive stillet videre til en medarbejder.",
  livechatHandoverDeclined: "Livechat afvist",
  livechatHandoverDeclinedDescription:
    "Kunden har afvist at blive stillet videre til en medarbejder.",
  conversationLivechatStarted: "Livechat startet",
  conversationLivechatEnded: "Livechat afsluttet",
  conversationLivechatEndedByCustomer: "Livechat afsluttet af kunden",
  conversationLivechatEndedByAgent: "Livechat afsluttet af medarbejderen",
  conversationLivechatEndedInactivity: "Livechat lukket efter inaktivitet",
  livechatPromptQuestionPlaceholder: "Vil du gerne tale med en medarbejder?",
  livechatPromptYesTextPlaceholder: "Ja tak",
  livechatPromptNoTextPlaceholder: "Nej tak",
  leadgenNameLabel: "Dit navn",
  leadgenNamePlaceholder: "Indtast dit navn",
  leadgenEmailLabel: "Din email",
  leadgenEmailPlaceholder: "Indtast din email",
  leadgenSubmitButton: "Send",
  leadgenFormVisualOnly: "Denne formular er kun til visning i dashboardet",
  searchInfoChunks: "Søg i dine info chunks...",
  selectOption: "Vælg mulighed",
  dateLabel: "Dato",
  purchaseLabel: "Køb",
  [duplicateTranslationKey("purchaseNo")]: "Ingen køb",
  withPurchase: "Med Køb",
  testConversationsFilter: "Test",
  testOriginFilterLabel: "Testkilde",
  testOriginAi: "AI",
  testOriginDashboard: "Dashboard",
  testOriginPortal: "Portal",
  testConversationBadgeAi: "Test (AI)",
  testConversationBadgeDashboard: "Test (Dashboard)",
  testConversationBadgePortal: "Test (Portal)",
  missingInfo: "Manglende Info",
  missingInfoFilterApplied: "Viser samtaler med manglende info",
  assign: "Tildel",
};
